<template>
	<div class="chat-overlays">
		<chat-floating-overlays
			ref="floatingOverlays"
			:group="group"
			:is-group="isGroup"
			@emotion="$emit('emotion', $event)"
			@invite-ok="$emit('invite-ok', $event)"
			@select-menu="$emit('select-menu', $event)"
		></chat-floating-overlays>
		<chat-dialog-overlays
			ref="dialogOverlays"
			:chat="chat"
			:friend="friend"
			:group="group"
			:group-members="groupMembers"
			:head-image="headImage"
			:is-group="isGroup"
			:show-name="showName"
			:show-record="showRecord"
			:show-top-message-dialog="showTopMessageDialog"
			:top-message-list="topMessageList"
			:top-message-loading="topMessageLoading"
			:can-manage-top-messages="canManageTopMessages"
			:top-message-removing-id="topMessageRemovingId"
			@update:show-top-message-dialog="$emit('update:show-top-message-dialog', $event)"
			@locate-quote="$emit('locate-quote', $event)"
			@close-record="$emit('close-record')"
			@send-record="$emit('send-record', $event)"
			@locate-top-message="$emit('locate-top-message', $event)"
			@remove-top-message="$emit('remove-top-message', $event)"
		></chat-dialog-overlays>
	</div>
</template>

<script>
import ChatDialogOverlays from "./ChatDialogOverlays.vue";
import ChatFloatingOverlays from "./ChatFloatingOverlays.vue";

export default {
	name: "chatOverlays",
	components: {
		ChatDialogOverlays,
		ChatFloatingOverlays
	},
	props: {
		chat: {
			type: Object,
			default: () => ({})
		},
		friend: {
			type: Object,
			default: () => ({})
		},
		group: {
			type: Object,
			default: () => ({})
		},
		groupMembers: {
			type: Array,
			default: () => []
		},
		headImage: {
			type: Function,
			default: () => ""
		},
		isGroup: {
			type: Boolean,
			default: false
		},
		showName: {
			type: Function,
			default: () => ""
		},
		showRecord: {
			type: Boolean,
			default: false
		},
		showTopMessageDialog: {
			type: Boolean,
			default: false
		},
		topMessageList: {
			type: Array,
			default: () => []
		},
		topMessageLoading: {
			type: Boolean,
			default: false
		},
		canManageTopMessages: {
			type: Boolean,
			default: false
		},
		topMessageRemovingId: {
			type: [Number, String],
			default: null
		}
	},
	methods: {
		openEmotion(pos) {
			const floatingOverlays = this.$refs.floatingOverlays;
			if (floatingOverlays && floatingOverlays.openEmotion) {
				floatingOverlays.openEmotion(pos);
			}
		},
		closeEmotion() {
			const floatingOverlays = this.$refs.floatingOverlays;
			if (floatingOverlays && floatingOverlays.closeEmotion) {
				floatingOverlays.closeEmotion();
			}
		},
		refreshCustomStickers() {
			const floatingOverlays = this.$refs.floatingOverlays;
			if (floatingOverlays && floatingOverlays.refreshCustomStickers) {
				floatingOverlays.refreshCustomStickers();
			}
		},
		openRightMenu(pos, items) {
			const floatingOverlays = this.$refs.floatingOverlays;
			if (floatingOverlays && floatingOverlays.openRightMenu) {
				floatingOverlays.openRightMenu(pos, items);
			}
		},
		openRtcSelector(maxSize, checkedIds, lockedIds, hideIds) {
			const floatingOverlays = this.$refs.floatingOverlays;
			if (floatingOverlays && floatingOverlays.openRtcSelector) {
				floatingOverlays.openRtcSelector(maxSize, checkedIds, lockedIds, hideIds);
			}
		},
		openChatSelector(callback) {
			const dialogOverlays = this.$refs.dialogOverlays;
			if (dialogOverlays && dialogOverlays.openChatSelector) {
				dialogOverlays.openChatSelector(callback);
			}
		},
		openRtcJoin(rtcInfo) {
			const dialogOverlays = this.$refs.dialogOverlays;
			if (dialogOverlays && dialogOverlays.openRtcJoin) {
				dialogOverlays.openRtcJoin(rtcInfo);
			}
		},
		openHistory() {
			const dialogOverlays = this.$refs.dialogOverlays;
			if (dialogOverlays && dialogOverlays.openHistory) {
				dialogOverlays.openHistory();
			}
		},
		closeHistory() {
			const dialogOverlays = this.$refs.dialogOverlays;
			if (dialogOverlays && dialogOverlays.closeHistory) {
				dialogOverlays.closeHistory();
			}
		}
	}
}
</script>
